<template lang="pug">
  div.wrap-item-counceling-checkbox.mb24
    span.block.bold.fz12.mb8 {{question}}
    div.f.flex-wrap
      v-checkbox(v-for="item in selection"
        :label="item"
        :value="item"
        v-model="answer").pr12
</template>

<style lang="scss">
.wrap-item-counceling-checkbox {
  .v-input--selection-controls {
    height: 32px;
  }
  .v-input--selection-controls {
    margin: 0 !important;
  }
  .v-input--selection-controls__input {
    margin-right: 4px !important;
  }
}
</style>

<script>
import db from "@/components/utils/firebase"

import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")

export default {
  props: {
    question: {
      type: String,
      required: true
    },
    selection: {
      type: Array,
      required: true
    },
    defaultAnswer: {
      validator: v => true, // Any
      default: null
    }
  },
  data () {
    return {
      answer: null
    }
  },
  watch: {
    defaultAnswer (val) {
      this.answer = this.defaultAnswer
    }
  },
  computed: {
    ...mapStateAuth(["uid"])
  },
  created () {
    if (this.defaultAnswer) this.answer = this.defaultAnswer
  },
  methods: {
    getAnswer () {
      return this.answer
    }
  }
}
</script>
